import { NativeStackHeaderProps, Stack } from 'expo-router';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ScrollView, StyleSheet, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import ContentList from 'shared/components/vxl/ContentList/ContentList';
import Illustration from 'shared/components/vxl/Illustration/Illustration';
import ExpoNavigationBar from 'shared/components/vxl/navigation/ExpoNavigationBar/ExpoNavigationBar';
import BodyBaseBoldText from 'shared/components/vxl/typography/primary/body/BodyBaseBoldText';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import TitleLgText from 'shared/components/vxl/typography/primary/title/TitleLgText';
import theme from 'shared/styles/theme';

const PayCheckScreen = () => {
  const { bottom } = useSafeAreaInsets();
  const { t: translatedText } = useTranslation('believe', {
    keyPrefix: 'makePayment',
  });

  return (
    <ScrollView
      style={styles.scrollView}
      contentContainerStyle={[styles.container, { paddingBottom: bottom }]}
    >
      <View style={styles.screen}>
        <Stack.Screen
          options={{
            title: '',
            headerBackVisible: true,
            headerShown: true,
            header: (props: NativeStackHeaderProps) => (
              <ExpoNavigationBar {...props} />
            ),
          }}
        />
        <View style={styles.illustration}>
          <Illustration illustration="SIGN_A" />
        </View>
        <TitleLgText numberOfLines={2}>
          {translatedText('payByCheck.title')}
        </TitleLgText>
        <ContentList
          contentList={[
            translatedText('payByCheck.bullets.one'),
            translatedText('payByCheck.bullets.two'),
            <>
              <BodyBaseText>
                {translatedText('payByCheck.bullets.three')}
              </BodyBaseText>
              <BodyBaseBoldText>
                {translatedText('payByCheck.bullets.threePoBox')}
              </BodyBaseBoldText>
            </>,
            translatedText('payByCheck.bullets.four'),
            translatedText('payByCheck.bullets.five'),
            translatedText('payByCheck.bullets.six'),
          ]}
        />
      </View>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.color.background.primary,
    padding: theme.spacing.m,
  },
  illustration: {
    alignSelf: 'center',
    height: 200,
    width: 200,
  },
  screen: {
    flex: 1,
    gap: theme.spacing.m,
  },
  scrollView: {
    backgroundColor: theme.color.background.primary,
  },
});

export default PayCheckScreen;
